import React from 'react';

interface DoodleMascotProps {
  style?: React.CSSProperties;
  className?: string;
}

export const DoodleMascot: React.FC<DoodleMascotProps> = ({
  style,
  className,
}) => (
  <svg
    viewBox="0 0 32 32"
    width="1em"
    height="1em"
    style={style}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient id="doodle-body" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0%" stopColor="#f59e0b" />
        <stop offset="100%" stopColor="#fbbf24" />
      </linearGradient>
    </defs>
    {/* Squiggly trail */}
    <path
      d="M2,28 Q5,24 4,21 Q3,18 6,16 Q9,14 7,11"
      fill="none"
      stroke="#a78bfa"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeDasharray="2 2"
      opacity="0.6"
    />
    {/* Pencil group rotated -30deg around center */}
    <g transform="rotate(-30, 16, 16)">
      {/* Eraser */}
      <rect x="13" y="2" width="6" height="4" rx="1.5" fill="#f472b6" />
      <line x1="13" y1="6" x2="19" y2="6" stroke="#ec4899" strokeWidth="0.5" />
      {/* Body */}
      <rect x="13" y="6" width="6" height="16" fill="url(#doodle-body)" />
      {/* Wood collar */}
      <rect x="13" y="22" width="6" height="3" fill="#d97706" />
      <polygon points="13,22 14,25 13,25" fill="#b45309" opacity="0.4" />
      <polygon points="19,22 18,25 19,25" fill="#b45309" opacity="0.4" />
      {/* Graphite tip */}
      <polygon points="13,25 19,25 16,30" fill="#374151" />
      <polygon points="15,27 17,27 16,30" fill="#1f2937" />
      {/* Eyes */}
      <circle cx="15" cy="12" r="0.9" fill="#1f2937" />
      <circle cx="17" cy="12" r="0.9" fill="#1f2937" />
      {/* Smile */}
      <path
        d="M14.8,14 Q16,15.2 17.2,14"
        fill="none"
        stroke="#1f2937"
        strokeWidth="0.6"
        strokeLinecap="round"
      />
    </g>
  </svg>
);
